import React from 'react';
import { Skeleton } from '../../components/ui/Skeleton';

export const WalletSectionSkeleton = () => (
  <div className="space-y-5" aria-busy="true" aria-live="polite">
    <div className="flex items-end justify-between rounded-2xl border border-border px-4 py-4">
      <div className="space-y-2">
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-9 w-44" />
      </div>
      <Skeleton className="h-9 w-24 rounded-xl" />
    </div>

    <div className="grid gap-5 lg:grid-cols-2">
      <div className="rounded-2xl border border-border p-4 md:p-5">
        <Skeleton className="h-4 w-24" />
        <div className="mt-4 grid grid-cols-3 gap-2">
          <Skeleton className="h-10 rounded-xl" />
          <Skeleton className="h-10 rounded-xl" />
          <Skeleton className="h-10 rounded-xl" />
        </div>
        <Skeleton className="mt-4 h-12 w-full rounded-2xl" />
        <Skeleton className="mt-4 h-12 w-full rounded-2xl" />
        <Skeleton className="mt-6 h-12 w-full rounded-xl" />
        <Skeleton className="mt-3 h-11 w-full rounded-xl" />
      </div>

      <div className="rounded-2xl border border-border p-4 md:p-5">
        <Skeleton className="h-4 w-20" />
        <Skeleton className="mt-4 h-10 w-full rounded-2xl" />
        <ul className="mt-4 space-y-2">
          {[0, 1, 2, 3].map((item) => (
            <li key={item} className="py-2">
              <Skeleton className="h-4 w-2/5" />
              <Skeleton className="mt-2 h-3 w-1/3" />
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);
